import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-with-hold',
  templateUrl: './with-hold.component.html',
  styleUrls: ['./with-hold.component.scss']
})
export class WithHoldComponent implements OnInit {
  APIService: string;
  WithHoldForm: FormGroup;
  Table = false; 
  filteredstucourseClgMapListList: any;
  courseClgMapList: any;
  ListOfRgNo: any;
  filteredListOfRgNo: any;
  filteredCodeList: any;
  ListCode: any;
  ListOfEcId: any;
  filteredList: any;
  WithHoldArray: FormArray;
  pageSize = 50;
  currentPage = 1;
  totalItems = 0;
  pageSizeOptions: number[] = [50, 100, 150, 200];
  WithHold: any;
  errMsg: any;
  dialogRef: MatDialogRef<any>;
  SessionNo: any;
  assignTableData: any;
  ListOfGrid: any;
  rollNoArray: any;
  collegeList: any;
  filteredCollegeList: any;
  userId: string;
  userData = {
    LoginFullName: 'N/A'
  }
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    this.APIService = environment.serviceUrl;
  }
  ngOnInit(): void {
    this.fetchCode();
    this.userId = sessionStorage.getItem('userId');
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchList(this.SessionNo);
    }
    this.Table = false;
    this.WithHoldForm = this.fb.group({
      list: new FormControl(''),
      list2: new FormControl(''),
      list3: new FormControl('New'),
      CgCode: new FormControl(''),
      Valid: new FormControl(''),
      Chng: new FormControl(''),
      Batch: new FormControl(''),
      RgNo: new FormControl(''),
      Code: new FormControl(''),
      SetRem: new FormControl(''),
      Existing: new FormControl(''),
      Valid2: new FormControl(''),
      WithHoldArray: new FormArray([]),     
    })
    this.getUserData(this.userId);
    this.getCourseData('')
    // this.fetchListForRgNo('')
    
    // this.addNewRow()
    this.getCollegeData();
  }

  getWithHoldArrayControls() {
    return (this.WithHoldForm.get('WithHoldArray') as FormArray).controls;
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.fetchList(this.SessionNo);
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    }
    );
  }

  addNewRow() {
    const creds = this.WithHoldForm.controls.WithHoldArray as FormArray;
    creds.push(
      this.fb.group({
        GridBatch: new FormControl(''),
        GridRgNo: new FormControl(''),
        GridCode: new FormControl(''),
        GridSetRem: new FormControl(''),
        GridExist: new FormControl(''),
        GridChng: new FormControl(''),
        GridValid: new FormControl(''),
        GridMesg: new FormControl(''),
        GridSr: new FormControl(''),
      })
    );
  }

  getCourseData(id) {
    this.spinner.show()
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.courseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.courseClgMapList.slice();
      }
      else{
        this.spinner.hide()
        this.courseClgMapList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseClgMapList = [];
    });

  }

  fetchListForRgNo(item) {
    let payload = {}
    payload['CoCode'] = item.EmCoCode,
    this.ListOfRgNo = [];
    this.filteredListOfRgNo = [];
    this.umsService.fetchRegNoList(payload).subscribe((res) => {
      console.log('res.data',res.data)
      if (res.status) {
        
        this.ListOfRgNo = res.data;
        this.filteredListOfRgNo = this.ListOfRgNo.slice();
      }
      else {
 
      }
 
    });
 
  }

  fetchCode(){
    const payload = {};
    payload['CdType'] = 'EX';
    this.ListCode = [];
    this.filteredCodeList = [];
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListCode = res.data;
        // this.filteredCodeList = this.ListCode.slice();
        this.filteredCodeList = res.data.filter((item) => item.CdCode === 'WH');
        // this.studentStatus.controls['StatusRg'].setValue(['LEFT']);
      } else {
        
      }
    });
  }

  fetchList(SessionNo){
    let payload = {}
    payload["SnNo"] = SessionNo;
    payload["InCode"] = 9;
    payload["OpId"] = parseInt(sessionStorage.getItem('userId'))
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfEcId = res.data;
        this.filteredList = this.ListOfEcId.slice();
        // this.studentStatus.controls['StatusRg'].setValue(['LEFT']);
      } else {
        this.ListOfEcId = [];
        this.filteredList = [];
      }
    });
  }

  getList(data){
    this.WithHoldForm.controls['list'].markAsTouched();
    if (this.WithHoldForm.controls['list'].valid) {
      this.Table = true;
      this.loadGrid();
    } else {
      // Optional: handle invalid case
    }
    // this.Table = true;
    // this.WithHoldArray = this.WithHoldForm.get('WithHoldArray') as FormArray;
    // data.map((element, i) => {
    //   this.WithHoldArray.at(i).get('GridBatch').setValue(element['GridBatch']);
    //   this.WithHoldArray.at(i).get('GridRgNo').setValue(element['GridRgNo']);
    //   this.WithHoldArray.at(i).get('GridCode').setValue(element['GridCode']);
    //   this.WithHoldArray.at(i).get('GridSetRem').setValue(element['GridSetRem']);
    //   this.WithHoldArray.at(i).get('GridExist').setValue(element['GridExist']);
    //   this.WithHoldArray.at(i).get('GridChng').setValue(element['GridChng']);
    //   this.WithHoldArray.at(i).get('GridValid').setValue(element['GridValid']);
    //   this.WithHoldArray.at(i).get('GridMesg').setValue(element['GridMesg']);
    //   this.WithHoldArray.at(i).get('GridSr').setValue(element['GridSr']);  
    // });
    // this.loadGrid();
    // if(this.WithHoldForm.value['list'] == '' || this.WithHoldForm.value['list'] == null){
    //   this.WithHoldForm.get('list').markAsTouched();
    // } 
    // else{
    //   this.loadGrid('new');
    // }
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    // this.loadGrid('new');
  }

  loadGrid(){
    this.ListOfGrid = []
    this.assignTableData = []
    this.WithHoldArray = this.WithHoldForm.get('WithHoldArray') as FormArray;
    this.WithHoldArray.clear();
      this.spinner.show();
      let payload = {};
      payload['EcId'] = this.WithHoldForm.value['list'] ? this.WithHoldForm.value['list'] : 19760;
      payload['Chng'] = this.WithHoldForm.value['Chng'] ? this.WithHoldForm.value['Chng'] : '';
      payload['Valid'] = this.WithHoldForm.value['Valid'] ? this.WithHoldForm.value['Valid'] : '';
      payload['CgCode'] = this.WithHoldForm.value['CgCode'] ? this.WithHoldForm.value['CgCode'] : '';
      this.umsService.SearchWithHold(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.ListOfGrid = res.data;
          // this.Table = true;
          this.spinner.hide();
          this.assignTableData = res.data;
          this.assignTableData.forEach((element, i) => {
            const creds = this.WithHoldForm.get('WithHoldArray') as FormArray
            creds.push(
              this.fb.group({
                GridBatch: new FormControl(element['Batch']),
                GridRgNo: new FormControl(element['RgNo']),
                GridCode: new FormControl(element['ExcpCode']),
                GridSetRem: new FormControl(element['SetRem']),
                GridExist: new FormControl(element['EfExcp']),
                GridChng: new FormControl(element['Chng']),
                GridValid: new FormControl(element['Valid']),
                GridMesg: new FormControl(element['Mesg']),
                GridSr: new FormControl(element['Sr'])
              })
            );
          });
        }
        else{
          this.WithHoldForm.controls['list'].markAsTouched();
          // this.Table = false;
          
          this.spinner.hide()
          this.assignTableData = []
          this.ListOfGrid = []
          this.totalItems = 0;
        }
        // if (res.status) {
        //   this.spinner.hide();
        //   res.data.forEach(element => {
        //     if (value == 'new') {
        //       this.addNewRow();
        //     }
        //     else if (value == 'updated') {
        //       this.addNewRow();
        //     }
        //     else if (value == 'second updated') {
        //       this.addNewRow();
        //     }
        //   });
         
        //   this.ListOfGrid = res.data;
        //   this.totalItems = res.data[0].TotalRecords;
        //   this.assignTableData = res.data;
        //   this.WithHoldArray = this.WithHoldForm.get('WithHoldArray') as FormArray;
        //   this.assignTableData.map((element, i) => {
        //     this.WithHoldArray.at(i).get('GridBatch').setValue(element['Batch']);
        //     this.WithHoldArray.at(i).get('GridRgNo').setValue(element['RgNo']);
        //     this.WithHoldArray.at(i).get('GridCode').setValue(element['ExcpCode']);
        //     this.WithHoldArray.at(i).get('GridSetRem').setValue(element['SetRem']);
        //     this.WithHoldArray.at(i).get('GridExist').setValue(element['EfExcp']);
        //     this.WithHoldArray.at(i).get('GridChng').setValue(element['Chng']);
        //     this.WithHoldArray.at(i).get('GridValid').setValue(element['Valid']);
        //     this.WithHoldArray.at(i).get('GridMesg').setValue(element['Mesg']);
        //     this.WithHoldArray.at(i).get('GridSr').setValue(element['Sr']);  
        //   });
        // }
        // else {
        //   this.spinner.hide();
        //   this.ListOfGrid = []
        //   this.totalItems = 0;
        //   this.assignTableData = []

        // }

      });
  }

  ICR(){

  }

  print(){
    
  }

  AddWithHold(){
    let submitpayload = {};
    submitpayload = this.WithHoldForm.value;
    this.spinner.show();
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.WithHoldForm.value['list'] ? this.WithHoldForm.value['list'] : '';
    payload['Batch'] = this.WithHoldForm.value['Batch'] ? this.WithHoldForm.value['Batch'] : '';
    payload['Sr'] = this.WithHoldForm.value['Sr'] ? this.WithHoldForm.value['Sr'] : 0;
    payload['RollNo'] = this.WithHoldForm.value['RollNo'] ? this.WithHoldForm.value['RollNo'] : 0;
    payload['RgNo'] = this.WithHoldForm.value['RgNo'] ? this.WithHoldForm.value['RgNo'] : 0;
    payload['ExcpCode'] = this.WithHoldForm.value['Code'] ? this.WithHoldForm.value['Code'] : '';
    payload['SetRem'] = this.WithHoldForm.value['SetRem'] ? this.WithHoldForm.value['SetRem'] : '';
    this.umsService.AddWithHold(payload).subscribe((res) => {
      if(res.status){
        this.validate();
      }
      else{
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
    
  }

  validate(){
    this.spinner.show();
    let submitpayload = {};
    submitpayload = this.WithHoldForm.value;
    let payload = {};
    payload['EcId'] = submitpayload['list'];
    payload['Batch'] = submitpayload['Batch'] ? submitpayload['Batch'] : '';
    payload['Sr'] = '';
    payload['Valid'] = submitpayload['Valid'] ? submitpayload['Valid'] : '';
    this.umsService.VldtWithHold(payload).subscribe((res) => {
      this.spinner.hide();
      // if (res.message == '') {
      this.loadGrid();
      let data = {};
      data['message'] = res.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  Save(){
    if(this.WithHoldForm.invalid){
      this.WithHoldForm.get('list').markAsTouched();
      this.WithHoldForm.get('RgNo').markAsTouched();
      this.WithHoldForm.get('Code').markAsTouched();
      this.WithHoldForm.get('SetRem').markAsTouched();
    }
    else{
      this.AddWithHold();
    }
  }

  update(){
    this.spinner.show();
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.WithHoldForm.value['list'] ? this.WithHoldForm.value['list'] : '';
    payload['Batch'] = this.WithHoldForm.value['Batch'] ? this.WithHoldForm.value['Batch'] : '';
    payload['Sr'] = this.WithHoldForm.value['Sr'] ? this.WithHoldForm.value['Sr'] : 0;
    payload['RollNo'] = this.WithHoldForm.value['RollNo'] ? this.WithHoldForm.value['RollNo'] : 0;
    payload['RgNo'] = this.WithHoldForm.value['RgNo'] ? this.WithHoldForm.value['RgNo'] : 0;
    payload['ExcpCode'] = this.WithHoldForm.value['Code'] ? this.WithHoldForm.value['Code'] : '';
    payload['SetRem'] = this.WithHoldForm.value['SetRem'] ? this.WithHoldForm.value['SetRem'] : '';
    this.umsService.UpdtWithHold(payload).subscribe((res) => {
      if(res.status){
        this.validate();
      }
      else{
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
    
  }

  addnewrecord(){
    // this.WithHoldForm.controls['RgNo'].setValue('');
    // this.WithHoldForm.controls['Batch'].setValue('');
    // this.WithHoldForm.controls['Code'].setValue('');
    // this.WithHoldForm.controls['SetRem'].setValue('');
    // this.WithHoldForm.controls['Chng'].setValue('');
    // this.WithHoldForm.controls['Valid'].setValue('');
    // this.WithHoldForm.controls['Existing'].setValue('');
    this.WithHoldForm.get('Batch').reset();
    this.WithHoldForm.get('RgNo').reset();
    this.WithHoldForm.get('Code').reset();
    this.WithHoldForm.get('SetRem').reset();
  }

  prepopulate(data){
    this.WithHoldForm.controls['RgNo'].setValue(data.value.GridRgNo);
    this.WithHoldForm.controls['Batch'].setValue(data.value.GridBatch);
    this.WithHoldForm.controls['Code'].setValue(data.value.GridCode);
    this.WithHoldForm.controls['SetRem'].setValue(data.value.GridSetRem);
    this.WithHoldForm.controls['Chng'].setValue(data.value.GridChng);
    this.WithHoldForm.controls['Valid'].setValue(data.value.GridValid);
    this.WithHoldForm.controls['Existing'].setValue(data.value.GridExist);
  }

  delete(){
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.WithHoldForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(id){
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EcId: id.list,
        Batch: id.Batch,
        Sr: '',
        RollNo: 0,
        RgNo: id.RgNo,
        ExcpCode: id.Code,
        SetRem: id.SetRem,

      },
    };
    this.httpClient.delete(this.APIService + '/inputs/EditExcp', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          // this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  getUserData(id) {
    this.umsService.getUserData(id).subscribe((res) => {
      this.userData = res.data[0][0];
      sessionStorage.setItem('userType', res.data[0][0].LoginLevel)
      this.WithHoldForm.patchValue({
        list2: this.userData.LoginFullName
    });
      // this.usertyp();
    });
  }


  back(){
    // this.WithHoldForm.reset();
    // this.WithHoldForm.get('Batch').reset();
    // this.WithHoldForm.get('RgNo').reset();
    // this.WithHoldForm.get('Code').reset();
    // this.WithHoldForm.get('SetRem').reset();
    this.WithHoldForm.controls['RgNo'].setValue('');
    this.WithHoldForm.controls['Batch'].setValue('');
    this.WithHoldForm.controls['Code'].setValue('');
    this.WithHoldForm.controls['SetRem'].setValue('');
    this.WithHoldForm.controls['Chng'].setValue('');
    this.WithHoldForm.controls['Valid'].setValue('');
    this.WithHoldForm.controls['Existing'].setValue('');
    this.Table = false
  }
  // reset(){
  //   this.WithHoldForm.get('Batch').reset();
  //   this.WithHoldForm.get('RgNo').reset();
  //   this.WithHoldForm.get('Code').reset();
  //   this.WithHoldForm.get('SetRem').reset();
  // }

}
